<script>
    import { version } from "./version.js";
    import { bgColor } from "./stores/background_color.js";
    import Logo from "./Logo.svelte";

    //flickering effect
    $: brightness = 100;

    function flicker() {
        // 90% chance to just jitter slightly
        // 10% chance to "drop out" (the flicker)
        let chance = Math.random();

        if (chance > 0.85) {
            brightness = Math.random() * 50; // Deep dip
        } else {
            brightness = 85 + Math.random() * 35; // Normal hum
        }

        // Randomize the timing of the next flicker for "organic" feel
        setTimeout(flicker, Math.random() * 150);
    }

    flicker();
</script>

<div class="bg">
    <!-- <div class="version-and-credit">
    <img class="logo" src="./images/logo.svg" alt="" />
    

        <p class="version">Version {version}</p>
        <p class="miniavs-credit">
            Lovely avatars by <a
                href="https://www.figma.com/community/file/923211396597067458/miniavs-free-avatar-creator"
                >Webpixels!</a
            >
        </p>
    </div> -->

    <div class="logo">
        <Logo size={110} />
    </div>

    <div class="myDetails">
        <div class="icons">
            <a href="https://dan-levin-resume.netlify.app/">
                <div
                    class="glow"
                    style="box-shadow: 0px 0px 20px 8px {$bgColor};"
                ></div>
                <i class="fa-solid fa-child"></i>
            </a>
            <a href="https://github.com/pipboy9000/" style="color:{bgColor};">
                <div
                    class="glow"
                    style="box-shadow: 0px 0px 20px 8px {$bgColor};"
                ></div>
                <i
                    class="fa-brands fa-github"
                    style="filter: brightness({brightness / 100})"
                ></i>
            </a>
            <a href="https://www.facebook.com/dan.levin.98">
                <div
                    class="glow"
                    style="box-shadow: 0px 0px 20px 8px {$bgColor};"
                ></div>
                <i class="fa-brands fa-facebook"></i>
            </a>
            <a href="https://i-r-programmer.blogspot.com/">
                <div
                    class="glow"
                    style="box-shadow: 0px 0px 20px 8px {$bgColor};"
                ></div>
                <i class="fa-brands fa-blogger-b"></i>
            </a>
            <a href="https://dan-levin-resume.netlify.app/">
                <div
                    class="glow"
                    style="box-shadow: 0px 0px 20px 8px {$bgColor};"
                ></div>
                <i class="fa-solid fa-fish"></i>
            </a>
        </div>
    </div>
</div>
<div class="bottom">
    <p>V {version}</p>
    <p>Lovely avatars by</p>
    <a
        href="https://www.figma.com/community/file/923211396597067458/miniavs-free-avatar-creator"
    >
        <span style="color: {$bgColor};">Webpixels!</span>
    </a>
</div>

<style>
    .bg {
        height: 280px;
        width: 100vw;
        padding: 32px;
        background-color: #3b3b3bf0;
        color: white;
        box-sizing: border-box;
        position: relative;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        display: flex;
        justify-content: center;
        font-size: 20px;
        /* gap: 10px; */
    }

    .bottom {
        padding: 8px;
        box-sizing: border-box;
        background: white;
        color: #3b3b3bf0;
        display: flex;
        gap: 8px;
    }
    .logo {
        filter: saturate(2) brightness(1.5);
    }

    .myDetails {
        z-index: 1;
        padding-top: 30px;
    }

    .icons {
        gap: 38px;
        display: flex;
        font-size: 22px;
        flex-wrap: wrap;
        justify-content: center;
    }

    a {
        color: unset;
        display: flex;
        align-items: center;
        justify-content: center;
        filter: hue-rotate(calc(sibling-index() * 60deg)) brightness(1.2) saturate(2.5);
    }

    a:hover {
        text-decoration: none;
    }

    .glow {
        box-shadow: 0 0 20px 8px white;
        border-radius: 100px;
        width: 0;
        height: 0;
        position: absolute;
    }
</style>
